var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5925 15.75L2.25 8.4075V9.9075C2.25 10.305 2.4075 10.6875 2.6925 10.965L8.535 16.8075C9.12 17.3925 10.0725 17.3925 10.6575 16.8075L15.315 12.15C15.9 11.565 15.9 10.6125 15.315 10.0275L9.5925 15.75Z",
    className: "svgFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.535 13.0575C8.8275 13.35 9.21 13.5 9.5925 13.5C9.975 13.5 10.3575 13.35 10.65 13.0575L15.3075 8.4C15.8925 7.815 15.8925 6.8625 15.3075 6.2775L9.465 0.435C9.1875 0.1575 8.805 0 8.4075 0H3.75C2.925 0 2.25 0.675 2.25 1.5V6.1575C2.25 6.555 2.4075 6.9375 2.6925 7.215L8.535 13.0575ZM3.75 1.5H8.4075L14.25 7.3425L9.5925 12L3.75 6.1575V1.5Z",
    className: "svgFill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 4.125C5.95527 4.125 6.375 3.70527 6.375 3.1875C6.375 2.66973 5.95527 2.25 5.4375 2.25C4.91973 2.25 4.5 2.66973 4.5 3.1875C4.5 3.70527 4.91973 4.125 5.4375 4.125Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.11ba15946998f02cf5c9c7cd53ada061.svg";
export { ForwardRef as ReactComponent };